import { computed, type ComputedRef } from 'vue'
import { useSamudkoyStore } from '../../stores/samudkoy'
import { simakatraConfig } from '@/core/config'


interface UseIdleFlipup {
  debugging: ComputedRef<boolean>
  timeout: ComputedRef<number>
  isActivated: ComputedRef<boolean>
  doTimeout: Function
}

//------------------------------------------------
export function useIdleFlipup(): UseIdleFlipup {
  const samudkoyStore = useSamudkoyStore()

  const debugging = computed(() => simakatraConfig.samudkoy.idleFlipup?.debugging ?? true)
  const timeout = computed(() => (simakatraConfig.samudkoy.idleFlipup?.timeoutSec ?? 5) * 1000)
  const isActivated = computed(() => samudkoyStore.isActivated)

  function doTimeout() {
    samudkoyStore.translateOff()
    samudkoyStore.flipUp(true)
  }

  return {
    debugging,
    timeout,
    isActivated,
    doTimeout,
  }
}

//------------------------------------------------
export function useIdleFlipupMock(): UseIdleFlipup {
  const debugging = computed(() => true)
  const timeout = computed(() => 3000)
  const isActivated = computed(() => true)

  function doTimeout() {
    console.debug('doTimeout()')
  }

  return {
    debugging,
    timeout,
    isActivated,
    doTimeout,
  }
}
